/**
 * 「创建 → 分镜 → 出片」步骤指示器(波1,D4)。
 *
 * ═══ 为什么只加一条指示器,不拆页 ═══════════════════════════════════════════════
 * 创建页 1664 行里其实**已经**藏着三段流程:填 brief(创建)→ 编排出 `panelScenes` 后
 * 同页切换成导演台逐镜改(分镜)→ 提交生成落详情页(出片)。但页面从头到尾只有一个
 * 「新建视频」标题,用户不知道自己在第几步、后面还有几步 —— 尤其"编排"之后页面**原地**
 * 换了内容,像是被换了一页却没有任何交代。
 * 拆成三个路由的收益抵不上风险(D4:拆 1664 行巨页风险高收益低),所以补的是**感知**:
 * 三步条把已经存在的状态显式说出来。
 *
 * ★视觉件已抽成共享 `shared/ui/StepIndicator`(海报舱两条管线同构,详见那个文件头);
 * 本文件只剩「视频这条管线的三个步骤名」这一份领域数据。
 *
 * ★纯视觉、零新状态:当前步由**现有** state 派生(派生函数在 `model/videoStep.ts`)——
 * 没分镜 → 第1步;有分镜 → 第2步;正在提交出片 → 第3步。它不驱动任何东西,只是读出来。
 * 也因此它**不可点**:点它跳不过去(没编排就没有分镜可改),做成可点的假导航更糟。
 *
 * ★0914 拍板(自由创作四改):自由创作(isFreeFlow)只直发,没有「分镜」这一幕 ——
 * 三步条硬套上去会平白多出一步用户永远走不到。`free` 传 true 时换成两步
 * 「创建 › 出片」,`current` 仍吃 `videoStepOf` 原样的返回值(自由流下 hasStoryboard
 * 恒为 false,`videoStepOf` 只会给 1 或 3,这里按「非 1 即出片」折成 1|2,不必另起
 * 一套自由流专用的步数派生)。
 */
import { StepIndicator } from "@/shared/ui/StepIndicator";
import type { VideoStep } from "../../model/videoStep";

/** 视频管线三步(领域数据;视觉与纪律在 shared/ui/StepIndicator)。 */
const STEPS = ["创建", "分镜", "出片"] as const;
/** 自由创作两步(没有「分镜」这一幕)。 */
const FREE_STEPS = ["创建", "出片"] as const;

export function VideoStepIndicator({
  current,
  free,
}: {
  current: VideoStep;
  /** 自由创作(isFreeFlow):步骤条按两步「创建 › 出片」渲染,不显「分镜」。 */
  free?: boolean;
}) {
  if (free) {
    return (
      <StepIndicator
        steps={FREE_STEPS}
        current={current === 1 ? 1 : 2}
        label="视频创作流程"
        domainAttr="data-video-steps"
      />
    );
  }
  return (
    <StepIndicator
      steps={STEPS}
      current={current}
      label="视频创作流程"
      domainAttr="data-video-steps"
    />
  );
}
